export const VALIDATION_STATUS = {
	SUCCESS: "Success",
	WARNING: "Warning",
	ERROR: "Error",
} as const;

export type ValidationStatus = typeof VALIDATION_STATUS[keyof typeof VALIDATION_STATUS];

export interface ProductDto {
	id: string;
	componentTypeId?: string;
	name?: string;
}

export interface RuleResult {
	ruleName: string;
	message: string;
	shortMessage?: string;
	severity?: ValidationStatus;
	relatedProducts?: string[];
}

export interface ValidateConfigurationResponseDto {
	isValid: boolean;
	errors: RuleResult[];
	warnings: RuleResult[];
	passedRules: RuleResult[];
}

export interface ValidateConfigurationRequestDto {
	products: { id: string }[];
}

export interface CompatibilityValidationResult {
	isValid: boolean;
	errors: RuleResult[];
	warnings: RuleResult[];
	passedRules: RuleResult[];
	errorCount: number;
	warningCount: number;
	successCount: number;
	totalRules: number;
}

export interface RuleResultWithSeverity extends RuleResult {
	severity: Exclude<ValidationStatus, typeof VALIDATION_STATUS.SUCCESS>;
}

export interface BatchProductValidationResult {
	isValid: boolean;
	errors: RuleResultWithSeverity[];
	warnings: RuleResultWithSeverity[];
	passedRules: RuleResult[];
}

export interface BatchProductResult {
	productId: string;
	validationResult: BatchProductValidationResult;
}

export interface ValidateBatchProductsRequestDto {
	baseConfiguration: { id: string }[];
	productsToValidate: { id: string }[];
	productIdToReplace?: string | null;
}

export interface ValidateBatchProductsResponseDto {
	results: BatchProductResult[];
}

export interface ValidationResultDto {
	isValid: boolean;
	severity: ValidationStatus;
	messages: string[];
}

export interface ProductValidationResultDto {
	product: ProductDto;
	validationResult: ValidationResultDto;
}